import { Button, Typography } from "@mui/material";
import { hmLightTheme } from "../themes/hmTheme";

const HmPageHeaderTitle = ({ ...props }) => {
  const { title, sx, totalNumber } = props;
  let SxProps = { fontSize: "1.125rem", color: "black", fontWeight: "bold" };
  if (sx) {
    SxProps = { ...SxProps, ...sx };
  }
  return (
    <Typography variant="h3" sx={SxProps}>
      {ucFirst(title)}
      {totalNumber ? (
        <Button sx={{ textTransform: "capitalize", color: "black" }}>
          ( Total :{" "}
          <span style={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}>
            {totalNumber}
          </span>{" "}
          )
        </Button>
      ) : (
        ""
      )}
    </Typography>
  );
};
const ucFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export default HmPageHeaderTitle;
